import { render, staticRenderFns } from "./SysSetting.vue?vue&type=template&id=5913a740&scoped=true"
import script from "./SysSetting.vue?vue&type=script&lang=js"
export * from "./SysSetting.vue?vue&type=script&lang=js"
import style0 from "./SysSetting.vue?vue&type=style&index=0&id=5913a740&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5913a740",
  null
  
)

export default component.exports